import { render, staticRenderFns } from "./AssignStore.vue?vue&type=template&id=199e3616&scoped=true"
import script from "./AssignStore.vue?vue&type=script&lang=js"
export * from "./AssignStore.vue?vue&type=script&lang=js"
import style0 from "./AssignStore.vue?vue&type=style&index=0&id=199e3616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e3616",
  null
  
)

export default component.exports